import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Modal, Paragraph, Popover, Subheading } from '@treams/treams-ui';

import * as graphql from 'generated/graphql';
import { ConversationDateSelect } from 'conversations/CreateConversationSelectors';

export default function ChangeConversationDateModal(props: {
	id: string;
	deadline: Date;
	duration?: number;
	location?: string | null;
	enabled?: boolean;
	onCompleted?: () => void;
	onDismiss?: () => void;
}) {
	const { t } = useTranslation();
	const [deadline, setDeadline] = useState<Date | undefined>(props.deadline);
	const [duration, setDuration] = useState<number | undefined>(props.duration ?? 60);
	const [location, setLocation] = useState(props.location ?? '');
	const [success, setSuccess] = useState(false);

	const [commit] = graphql.useRescheduleEvaluationSubmissionMutation();

	return (
		<Popover visible center>
			<Modal width={400} height="auto">
				<Modal.Header
					title={t('evaluation.submission.changeConversationDate.title')}
					onClose={() => props.onDismiss?.()}
				/>
				{success ? (
					<Modal.Contents>
						<Subheading mb={1}>
							{t('evaluation.submission.changeConversationDate.success.title')}
						</Subheading>
						<Paragraph mb={3}>
							{t('evaluation.submission.changeConversationDate.success.description')}
						</Paragraph>
						<Button
							title={t('evaluation.submission.changeConversationDate.done')}
							onClick={() => {
								props.onCompleted?.();
								props.onDismiss?.();
							}}
						/>
					</Modal.Contents>
				) : (
					<>
						<Modal.Contents>
							<ConversationDateSelect
								invite
								value={{
									deadline,
									meetingDuration: duration,
									location,
								}}
								onChange={({ deadline, meetingDuration, location }) => {
									setDeadline(deadline);
									setDuration(meetingDuration);
									setLocation(location);
								}}
							/>
						</Modal.Contents>
						<Modal.FormFooter
							small
							saveTitle={t('evaluation.submission.changeConversationDate.save')}
							onCancel={props.onDismiss}
							onSave={async () => {
								await commit({
									variables: {
										input: {
											id: props.id,
											deadline,
											meeting:
												location === ''
													? { duration: duration ?? 60 }
													: { duration: duration ?? 60, location },
										},
									},
								});

								setSuccess(true);
							}}
						/>
					</>
				)}
			</Modal>
		</Popover>
	);
}
